import React from "react";
import { useNavigate } from "react-router-dom";
import ListeEmployesRHPage from "./ListeEmployesRHPage";
import EmployeRHCreateModal from "./EmployeRHCreateModal";

/**
 * Route dédiée : dashboard RH visible en arrière-plan, création en modale (pattern « Nouvel agent terrain »).
 */
export default function NouveauEmployeRHPage(): React.JSX.Element {
  const navigate = useNavigate();

  return (
    <div className="relative">
      <ListeEmployesRHPage />
      <EmployeRHCreateModal
        open
        onClose={() => navigate("/admin/rh/employes", { replace: true })}
      />
    </div>
  );
}
